import React, { useEffect } from 'react'
import { hrmsData } from './Components/HrmsData'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

const Hrms = () => {
  const navigate = useNavigate();
  const userType = useSelector((state) => state.auth.userType);

  useEffect(() => {
    // Redirect HRMS users to their profile page
    if (userType === 'hrms') {
      navigate('/hrms/my-profile', { replace: true });
    }
  }, [userType, navigate]);

  // If HRMS user, don't render anything (will redirect)
  if (userType === 'hrms') {
    return <div>Redirecting...</div>;
  }

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
        <ul className="row g-2 list-unstyled li_animate row-cols-lg-3 row-cols-md-3 row-cols-sm-2 row-cols-2 row-deck mb-lg-5 mb-4">
            {hrmsData.map((data, index) => {
                return (
                <li className="col" key={index}>
                    <Link className="card hr-arrow p-4" to={`/${data.path}`} title={data.path} style={{"--dynamic-color": data.theme_color}}>
                        {data.icon}
                        <h6 className="title mb-1">{data.title}</h6>
                        <p className="small text-muted mb-0 d-none d-xl-inline-flex">{data.text}</p>
                        <div className="go-corner">
                            <div className="go-arrow">→</div>
                        </div>
                    </Link>
                </li>
                )
            })}
        </ul>
    </div>
  )
}

export default Hrms